import { render, staticRenderFns } from "./tabWraper.vue?vue&type=template&id=4d4004d4"
import script from "./tabWraper.vue?vue&type=script&lang=js"
export * from "./tabWraper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports